import { Trophy, TrendingUp, CheckCircle2, AlertCircle, Sparkles, ChevronRight } from "lucide-react";

export default function ScoreProgress({ score, onItem }) {
  if (!score) return null;
  const pct = score.progress?.pct ?? 0;
  const target = score.progress?.target ?? 0;

  return (
    <div className="bg-[#121217] border border-white/[0.06] rounded-2xl p-6 space-y-5" data-testid="score-progress">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <h2 className="font-head text-xl font-semibold flex items-center gap-2"><Trophy className="h-5 w-5 text-[#FF7A00]" />Evolução no Score Mí Chamou</h2>
        <span className="text-sm px-3 py-1 rounded-full bg-[#FF4D00]/15 text-[#FF4D00] border border-[#FF4D00]/30 capitalize" data-testid="score-level">{score.level_label || score.level}</span>
      </div>

      <div>
        <div className="flex items-end justify-between mb-1.5">
          <span className="text-3xl font-bold mono" data-testid="score-value">{score.score}<span className="text-sm text-zinc-500 font-normal"> pts</span></span>
          {score.next_level && !score.gate_required && (
            <span className="text-xs text-zinc-500 mono">{score.score} / {target} pts</span>
          )}
        </div>
        <div className="h-3 w-full bg-white/5 rounded-full overflow-hidden">
          <div className="h-full rounded-full bg-gradient-to-r from-[#FF4D00] to-[#FF9500] transition-all" style={{ width: `${pct}%` }} data-testid="score-bar" />
        </div>
        <p className="text-sm text-zinc-400 mt-2 flex items-center gap-1.5" data-testid="score-next">
          <TrendingUp className="h-4 w-4 text-emerald-400" />
          {!score.next_level
            ? "Você atingiu o nível máximo. Parabéns!"
            : score.gate_required
              ? `Conclua os passos abaixo para chegar ao nível ${score.next_level_label}.`
              : `Faltam ${score.points_to_next} pontos para chegar ao nível ${score.next_level_label}.`}
        </p>
      </div>

      <div>
        <div className="text-xs uppercase tracking-widest text-zinc-500 mb-2 flex items-center gap-2"><Sparkles className="h-4 w-4" />Próximos passos para evoluir</div>
        <div className="space-y-1" data-testid="score-checklist">
          {(score.checklist || []).map((c, idx) => {
            const clickable = !c.done && !!onItem;
            return (
              <button
                key={c.key || idx}
                type="button"
                data-testid={`score-item-${c.key || idx}`}
                onClick={clickable ? () => onItem(c.key) : undefined}
                className={`w-full flex items-start gap-2.5 text-left rounded-xl px-2.5 py-2 transition-colors ${clickable ? "hover:bg-white/[0.04] cursor-pointer" : "cursor-default"}`}
              >
                {c.done
                  ? <CheckCircle2 className="h-4 w-4 text-emerald-400 mt-0.5 shrink-0" />
                  : <AlertCircle className="h-4 w-4 text-amber-400 mt-0.5 shrink-0" />}
                <div className="flex-1 min-w-0">
                  <span className={c.done ? "text-zinc-400 line-through" : "text-zinc-200"}>{c.label}</span>
                  {!c.done && c.hint && <p className="text-[11px] text-zinc-500">{c.hint}</p>}
                </div>
                {clickable && <ChevronRight className="h-4 w-4 text-[#FF7A00] mt-0.5 shrink-0" />}
              </button>
            );
          })}
        </div>
      </div>

      {(score.breakdown || []).length > 0 && (
        <div>
          <div className="text-xs uppercase tracking-widest text-zinc-500 mb-2">Pontos adquiridos</div>
          <div className="space-y-1" data-testid="score-history">
            {score.breakdown.map((b, idx) => (
              <div key={idx} className="flex items-center justify-between bg-[#09090B] border border-white/[0.04] rounded-lg px-3 py-1.5 text-sm">
                <span className="text-zinc-400">{b.label}</span>
                <span className="text-emerald-400 mono">+{b.points} pts</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
